<template functional>
  <div class="m-theme-warning-message-wrapper">
    <div class="m-theme-warning-message">
      <img class="warning-icon" src="./images/warning-icon.png">
      <p>{{ props.message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ThemeWarningMessage'
}
</script>

<style lang="scss" scoped>
.m-theme-warning-message-wrapper {
  padding: 4px 10px;
  background: #000;

  .m-theme-warning-message {
    position: relative;
    padding: 8px 10px 8px 36px;
    border: 1px solid #ffe79e;
    border-radius: 8px;
    background: #fffaeb;

    .warning-icon {
      position: absolute;
      top: 8px;
      left: 8px;
      width: 20px;
      height: 20px;
    }

    p {
      color: #333;
      font-size: 12px;
      line-height: 14px;
    }
  }
}

[data-mode="light"] .m-theme-warning-message-wrapper {
  background: #ffca27;
}
</style>
